// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1xg8R","disabled":"FileBtn_disabled__3R50w","warn":"FileBtn_warn__12LDC","fade":"FileBtn_fade__2_fI7"};